module.exports = __webpack_public_path__ + "images/goalie-bd2e40ba3b165f2a0bc2cf3c70cddb41.png";